import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import cloneDeep from 'lodash/cloneDeep';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { ItemsService } from '../../../../services/items.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'scaffold-data-array',
    templateUrl: './data-array.component.html',
    styleUrls: ['../../rendered.component.scss', './data-array.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DataArrayComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  destroy$: Subject<boolean> = new Subject<boolean>();
  changeDetection;
  prefix;
  _value;
  originalItems;
  @Input('value')
  set(val) {
    console.log('SET', val);
    this._value = val;
    if (val) {
      this.item.items = [];
      val.forEach(val => {
        this.item.items.push(
          this.mergeJson(cloneDeep(this.item.content), val, val)
        );
      });
    }
    this.update();
  }
  get() {
    return this._value;
  }
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private itemsService: ItemsService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.update();
      });
    this.data = /*this.data ||*/ this.itemsService.getData(
      this.info,
      this.item.name,
      this.item.datas
    );
    //console.log(this.item.name, this.item.paramprefix)
    this.prefix = '';
    if (this.item.paramprefix && this.item.paramprefix.length)
      this.prefix += this.item.paramprefix + '/';
    //console.log(this.prefix);
    let value = this.itemsService.get(
      this.itemsService.getData(this.info),
      this.prefix + this.item.name
    );
    console.log('VALUE', value);
    if (value) {
      // console.log(value);
      if (!this.item.items || !this.item.items.push) this.item.items = [];
      value.forEach((val, index) => {
        console.log('Current value', index, val);
        if (typeof val !== 'object' || Array.isArray(val) || val === null) {
          console.log(
            'Not an object, reseting',
            this.prefix + this.item.name + `/${index}`
          );
          val = {};
          this.itemsService.updateValue(
            this.prefix + this.item.name + `/${index}`,
            val,
            this.info
          );
        }
        this.item.items.push(
          this.mergeJson(cloneDeep(this.item.content), val, val)
        );
      });
    }
    this.itemsService
      .registerItem(this.info)
      .pipe(takeUntil(this.destroy$))
      .subscribe(d => {
        console.log('Updating', this.item.name, d[this.item.name]);
        let key = this.item.name;
        if (this.paramprefix && this.paramprefix.length > 0)
          key = this.paramprefix + '/' + key;
        if (this.itemsService.hasKey(d, key)) {
          console.log(key, d);
          let val;
          try {
            val = this.itemsService.get(d, key);
            console.log(val);
            console.log(this.item.value.length);
            this.item.datas = cloneDeep(val);
            console.log(val.length, this.item.value.length);
            if (!this.item.items || val.length !== this.item.items.length) {
              this.item.value = cloneDeep(val);
              console.log(val);
              if (val) {
                this.item.items = [];
                val.forEach(val => {
                  this.item.items.push(
                    this.mergeJson(cloneDeep(this.item.content), val, val)
                  );
                });
                console.log(this.item.items);
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
        this.update();
      });
    this.item.value = this.item.datas || [];
    this.item.value.forEach((val, index) => {
      console.log('Current value', index, val);
      if (typeof val !== 'object' || Array.isArray(val) || val === null) {
        console.log(
          'Not an object, reseting',
          this.prefix + this.item.name + `/${index}`
        );
        val = {};
        this.itemsService.updateValue(
          this.prefix + this.item.name + `/${index}`,
          val,
          this.info
        );
      }
    });
    this.originalItems = cloneDeep(this.item.items);
    this.itemsService
      .registerReset()
      .pipe(takeUntil(this.destroy$))
      .subscribe(r => {
        if (r == 'reset') this.item.items = cloneDeep(this.originalItems);
        else if ((r = 'saved')) this.originalItems = cloneDeep(this.item.items);
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  mergeJson(viewJson, dataJson, rootData) {
    var $this = this;
    if (!rootData) rootData = dataJson;
    //Make sure we are working with Json objects
    if ($this.toType(viewJson) == 'string') {
      viewJson = JSON.parse(viewJson);
    }
    if ($this.toType(dataJson) == 'string') {
      dataJson = JSON.parse(dataJson);
    }

    Object.keys(viewJson).forEach(function (key) {
      if (
        $this.toType(viewJson[key]) == 'array' ||
        $this.toType(viewJson[key]) == 'object'
      ) {
        $this.mergeJson(viewJson[key], dataJson, rootData);
      } else {
        if (key == 'name' && viewJson.name && viewJson.name.length > 0) {
          if (
            viewJson.type == 'data_array' ||
            viewJson.type == 'template_data_array'
          ) {
            /*  if (dataJson.hasOwnProperty(viewJson.name)) {
                viewJson.datas = dataJson[viewJson.name];
                viewJson.values = [];
                if (dataJson[viewJson.name].forEach && viewJson.content && viewJson.content.length > 0) {
                  var contents = viewJson.content;
                  viewJson.items = []
                  dataJson[viewJson.name].forEach(item => {
                    console.log(item)
                    let lo_content = JSON.parse(JSON.stringify(contents))
                    let indata = item;
                    $this.mergeJson(lo_content, indata, rootData || dataJson)
                    viewJson.items.push(lo_content)
                    viewJson.values.push({});
                  })
                }
              }
              console.log(viewJson.items);*/
          } else if (
            viewJson.type == 'select' &&
            viewJson.template_select &&
            viewJson.template_name
          ) {
            viewJson.in_data = dataJson;
            if (rootData.hasOwnProperty(viewJson.template_name)) {
              let value = rootData[viewJson.template_name];
              if (value) {
                let keys = value.match(/\[[^\]]+\]/g);
                if (keys) {
                  viewJson.options = keys.map(k => {
                    let key = k.replace(/[\[,\]]/g, '');
                    return { label: key, value: key };
                  });
                }
              }
            }
            $this.mergeJsonInner(dataJson, viewJson, viewJson[key], rootData);
          } else {
            $this.mergeJsonInner(dataJson, viewJson, viewJson[key], rootData);
          }
        } else {
          if (
            typeof viewJson[key] == 'string' &&
            viewJson[key].match(/\[[^\]]+\]/g)
          ) {
            //  console.log("READ DATA TEMPLATE IN SETTING")
            let matches = viewJson[key].match(/\[[^\]]+\]/g);
            //  console.log(matches);
            matches.forEach(match => {
              console.log(match);
              let ke = match.replace(/\[/, '').replace(/\]/, '');
              //   console.log(ke);
              //    console.log(JSON.stringify(dataJson[ke]))
              if (dataJson[ke]) {
                let re = new RegExp(
                  match.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                );
                //  console.log(re);
                //  console.log(dataJson[ke])
                viewJson[key] = viewJson[key].replace(re, dataJson[ke]);
                //  console.log(viewJson[key])
              }
            });
          }
        }
      }
    });

    return viewJson;
  }

  mergeJsonInner(dataJson, dataItem, searchKey, rootData) {
    var $this = this;
    Object.keys(dataJson).forEach(function (key) {
      if (
        ($this.toType(dataJson[key]) == 'array' ||
          $this.toType(dataJson[key]) == 'object') &&
        $this.toType(key) != 'string'
      ) {
        $this.mergeJsonInner(dataJson[key], dataItem, searchKey, rootData);
      } else {
        if (key == searchKey) {
          dataItem.value = dataJson[key];
        }
      }
    });
  }
  toType(obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  }
  addDataItem(item, obj, arr) {
    if (!obj[arr] || !obj[arr].push) {
      obj[arr] = [];
    }
    if (!this.item.items || !this.item.items.push) {
      this.item.items = [];
    }
    this.item.items.push(cloneDeep(this.item.content));
    obj[arr].push({});
    console.log(
      'updating ' + (this.prefix ? this.prefix : '') + this.item.name,
      {}
    );
    this.itemsService.updateValue(
      (this.prefix ? this.prefix : '') +
        this.item.name +
        '/' +
        (obj[arr].length - 1),
      {},
      this.info
    );
  }
  deletFromArray(item, obj, arr, index) {
    obj[arr].splice(index, 1);
    this.item.items.splice(index, 1);
    console.log(
      'updating ' + (this.prefix ? this.prefix : '') + this.item.name,
      obj[arr]
    );
    this.itemsService.updateValue(
      (this.prefix ? this.prefix : '') + this.item.name,
      obj[arr],
      this.info
    );
    this.redraw();
  }
}
